import { logError } from '../log/logger';
import AdParams from './adparams';
import * as AdEvent from '../core/events/ad.events';
/* eslint-disable no-undef */
const { version } = require('../../package.json');

export default class TpxPlayerTracker {
  constructor(typeContent) {
    this.typeContent = typeContent;
    if (typeof TpxTracker !== 'undefined') {
      this.customerId =
        this.typeContent === 'AD'
          ? process.env.TRACKER_CUSTOMER_ID_FOR_AD
          : process.env.TRACKER_CUSTOMER_ID_FOR_CONTENT;
      this.trackerId = TpxTracker.init(this.customerId, typeContent);
      this.impressionTypePRE = TpxTracker.IMPRESSION_TYPE.DISPLAY_PRE;
      this.impressionTypePOS = TpxTracker.IMPRESSION_TYPE.DISPLAY_POST;
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  setComonParams(mediationT, exInfo) {
    if (typeof TpxTracker !== 'undefined') {
      TpxTracker.setComonParams(mediationT, exInfo, version, this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  setComonContentParams(dataCommon) {
    if (typeof TpxTracker !== 'undefined') {
      TpxTracker.setCommonContentParams(dataCommon, this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  setContentParams(dataContent) {
    this.contentParams = dataContent;
    if (typeof TpxTracker !== 'undefined') {
      TpxTracker.setContentParams(dataContent, this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendRequestPublisher(adDataParams) {
    if (adDataParams instanceof AdParams && typeof TpxTracker !== 'undefined') {
      const adParams = Object.assign(adDataParams.build());
      TpxTracker.setAdParams(adParams, this.trackerId);
      TpxTracker.send(TpxTracker.EVENT_STATUS.REQUEST_PUBLISHER, '', this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendRequestDemand(adDataParams) {
    if (typeof TpxTracker !== 'undefined') {
      if (adDataParams instanceof AdParams) {
        const adParams = Object.assign(adDataParams.build());
        TpxTracker.setAdParams(adParams, this.trackerId);
      }
      TpxTracker.send(TpxTracker.EVENT_STATUS.REQUEST_DEMAND, '', this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendDelivery(adDataParams) {
    if (typeof TpxTracker !== 'undefined') {
      if (adDataParams instanceof AdParams) {
        const adParams = Object.assign(adDataParams.build());
        adParams.dl_win = 0;
        TpxTracker.setAdParams(adParams, this.trackerId);
      }
      TpxTracker.send(TpxTracker.EVENT_STATUS.DELIVERY, '', this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendDeliveryWinner(adDataParams) {
    if (typeof TpxTracker !== 'undefined') {
      if (adDataParams instanceof AdParams) {
        const adParams = Object.assign(adDataParams.build());
        adParams.dl_win = 1;
        TpxTracker.setAdParams(adParams, this.trackerId);
      }
      TpxTracker.send(TpxTracker.EVENT_STATUS.DELIVERY, '', this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendImpression(impressionType, adParams) {
    let impression = '';
    switch (impressionType) {
      case AdEvent.AdStarted:
        impression = TpxTracker.IMPRESSION_TYPE.START;
        break;
      case AdEvent.AdVideoFirstQuartile:
        impression = TpxTracker.IMPRESSION_TYPE.FIRSTQUARTILE;
        break;
      case AdEvent.AdVideoMidpoint:
        impression = TpxTracker.IMPRESSION_TYPE.MIDPOINT;
        break;
      case AdEvent.AdVideoThirdQuartile:
        impression = TpxTracker.IMPRESSION_TYPE.THIRDQUARTILE;
        break;
      case AdEvent.AdStopped:
        impression = TpxTracker.IMPRESSION_TYPE.COMPLETE;
        break;
      default:
        break;
    }
    if (typeof TpxTracker !== 'undefined') {
      if (adParams instanceof AdParams) {
        TpxTracker.setAdParams(adParams.build(), this.trackerId);
      } else if (this.typeContent === 'CONTENT') {
        TpxTracker.setContentParams(this.contentParams, this.trackerId);
      }

      TpxTracker.send(TpxTracker.EVENT_STATUS.IMPRESSION, impression, this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendError(adParams) {
    if (typeof TpxTracker !== 'undefined') {
      if (adParams instanceof AdParams) {
        TpxTracker.setAdParams(adParams.build(), this.trackerId);
      }

      TpxTracker.send(TpxTracker.EVENT_STATUS.ERROR, '', this.trackerId);
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  sendClick(adParams) {
    if (typeof TpxTracker !== 'undefined') {
      if (adParams instanceof AdParams) {
        TpxTracker.setAdParams(adParams.build(), this.trackerId);
      }

      TpxTracker.send(
        TpxTracker.EVENT_STATUS.IMPRESSION,
        TpxTracker.IMPRESSION_TYPE.CLICK,
        this.trackerId,
      );
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }

  getUrlTrackingForImpression(impressionType, adParams) {
    if (adParams instanceof AdParams) {
      TpxTracker.setAdParams(adParams.build(), this.trackerId);
    }
    return TpxTracker.getUrlTracking(
      TpxTracker.EVENT_STATUS.IMPRESSION,
      impressionType,
      this.trackerId,
    );
  }

  sendPlayerLoaded() {
    if (typeof TpxTracker !== 'undefined') {
      try {
        TpxTracker.send(TpxTracker.EVENT_STATUS.PLAYER_LOADED, '', this.trackerId);
      } catch (error) {
        logError(error);
      }
    } else {
      logError('[TpxPlayerTracker] TpxTracker is not defined.');
    }
  }
}
